import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Turmas } from './../../core/turmas';

import { ActivatedRoute, Router } from '@angular/router';
import { Acesso } from 'src/app/core/acesso';
import { CarregarPerfil } from 'src/app/core/carregar-perfil';
import { NiveisTurmas } from 'src/app/core/niveis-turmas';
import { Programa } from 'src/app/core/programa';
import { Projeto } from 'src/app/core/projeto';
import { Unidade } from 'src/app/core/unidade';
import { TurmasService } from 'src/app/services/turmas/turmas.service';
import { UnidadeService } from '../../services/unidade/unidade.service';
import { ConfirmDialogComponent } from '../common/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'turmas',
  templateUrl: './turmas.component.html',
  styleUrls: ['./turmas.component.css']
})
export class TurmasComponent implements OnInit {

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  turmas: Turmas[];
  turma: Turmas = new Turmas();
  msg: string;
  unidadeLogada: Unidade;
  perfilAcesso: Acesso = new Acesso();
  carregarPerfil: CarregarPerfil  = new CarregarPerfil();

  mostrarTabela = false;

  displayedColumns: string[] = ['descricao',  'programa', 'projeto', 'dataPrevisaoInicio', 'acoes'];
  dataSource: MatTableDataSource<Turmas> = new MatTableDataSource();
  menu: string;
  area: string;
  constructor(
    private turmasService: TurmasService,
    private router: Router,
    private dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private unidadeService: UnidadeService
  ) { }

  ngOnInit() {
    this.carregarPerfil.carregar(this.activatedRoute.snapshot.data.perfilAcesso, this.perfilAcesso);

    this.dataSource.paginator = this.paginator;
    this.area = this.getArea();
    this.unidadeService.getUnidadeLogada().subscribe((unidade: Unidade) => {
      this.unidadeLogada = unidade;
      this.getAll();
    });
  }

  getMenu(): string {
    const primeiroSegmento = this.router.url.split('/')[1];
    return primeiroSegmento.startsWith('menu') ? primeiroSegmento : undefined;
  }

  private getArea(): string {
    this.menu = this.getMenu();
    return this.menu && this.menu == "menu-sap" ? 'S' : (this.menu && this.menu == "menu-pedagogico" ? 'P' : null);
  }

  limpar() {
    this.mostrarTabela = false;
    this.turma = new Turmas();
    this.turma.programa = new Programa();
    this.turma.projeto = new Projeto();
    this.turma.unidade = new Unidade();
    this.turma.niveisTurma = new NiveisTurmas();
    this.dataSource.data = [];
  }

  consultar() {
    if (this.turma.id) {
      this.turmasService.getById(this.turma.id).subscribe((turma: Turmas) => {
        if (!turma){
          this.mostrarTabela = false;
          this.msg = 'Nenhum registro para a pesquisa selecionada';
        } else {
          this.dataSource.data = [turma];
          this.mostrarTabela = true;
        }
      })
    } else {
      this.getAll();
    }
  }


  atualizar(turma: Turmas) {
    if (turma?.oficinas?.length) {
      turma.oficinas.forEach(f => {
        f.area = this.area;
      });
    }
    if (this.menu) {
      this.router.navigate([this.menu + '/turmas/cadastrar'], { queryParams: { id: turma.id } });
    } else {
      this.router.navigate(['/turmas/cadastrar'], { queryParams: { id: turma.id } });
    }
  }  

  deletar(turma: Turmas) {
    this.chamaCaixaDialogo(turma);
  }

  chamaCaixaDialogo(turma: Turmas) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      pergunta: `Certeza que deseja excluir a turma ?`,
      textoConfirma: 'SIM',
      textoCancela: 'NÃO'
    };

    const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(confirma => {
      if (confirma) {
        this.turmasService.excluir(turma.id).subscribe(() => {
          this.turma.id = null;
          this.consultar();
        })
      } else {
        dialogRef.close();
      }
    }
    );
  }

  getAll() {
    this.turmasService.getFilter(null, null, this.unidadeLogada.idUnidade).subscribe((turmas: Turmas[]) => {
      this.turmas = turmas;
      this.dataSource.data = turmas ? turmas : [];
      this.verificaMostrarTabela(turmas);
    })
  }

  verificaMostrarTabela(turmas: Turmas[]) {
    if (!turmas || turmas.length === 0) {
      this.mostrarTabela = false;
      this.msg = 'Nenhuma turma cadastrada.';
    } else {
      this.mostrarTabela = true;
    }
  }


}
